import script from "./CompletePaymentComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletePaymentComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CompletePaymentComponent.vue?vue&type=style&index=0&id=3c21ad8a&lang=css"

const __exports__ = script;

export default __exports__